var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-button-container"},[_c('button',{staticClass:"home-button-content",on:{"click":_vm.home}})])
}
var staticRenderFns = []

export { render, staticRenderFns }